import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {getConfigByApp, utilServerSideDeviceDetection} from '@utils';
import {metaInfo} from '@configs';
import {HOME, REFUND} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {wrapper} from '@jobseeker/common-core/stores';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import RefundPolicyPage from '@components/Static/Refund';
import {useDispatch} from 'react-redux';
import {HiristBanner} from '@jobseeker/lotus/components';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import {BannerInfo} from '@jobseeker/lotus/components';
import {HiristRefundIcon} from '@jobseeker/lotus/assets/icons';
import type {GetServerSidePropsContext} from 'next/types';

type RefundProps = {
  seoConfig: object;
  isMobile: boolean;
};

const Refund = ({seoConfig, isMobile}: RefundProps) => {
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  const metaData = getConfigByApp(metaInfo, HOME, true, REFUND);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch);
  const breadcrumbElements = isAppIimjobs
    ? [
        {
          name: 'Home',
          item: '/',
        },
        {
          name: 'Refund Policy',
          item: '',
        },
      ]
    : [];

  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <ResponsiveLayout
          breadcrumbElements={breadcrumbElements}
          variant={VersionVariants.VERSION_TWO}
        >
          {!isAppIimjobs && (
            <HiristBanner>
              <BannerInfo
                Icon={HiristRefundIcon}
                isMobile={isMobile}
                title={''}
                subTitle={`Refund Policy`}
              />
            </HiristBanner>
          )}
          <RefundPolicyPage />
        </ResponsiveLayout>
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async (context: GetServerSidePropsContext) => {
    const seoConfig = await loadSEO(REFUND);

    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: REFUND},
    });
    const {isMobile} = utilServerSideDeviceDetection(context);
    if (isMobile) {
      store.dispatch({
        type: 'AppContext/set_layout_device',
        payload: 'mobile',
      });
    }

    return {
      props: {
        seoConfig,
        isMobile,
      },
    };
  }
);

export default Refund;
